import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import itCommon from './locales/it/common.json';
import itAuth from './locales/it/auth.json';
import itDashboard from './locales/it/dashboard.json';
import itInvoice from './locales/it/invoice.json';
import itClient from './locales/it/client.json';
import itSupplier from './locales/it/supplier.json';
import itOnboarding from './locales/it/onboarding.json';
import itProfile from './locales/it/profile.json';
import itProduct from './locales/it/product.json';
import itExpense from './locales/it/expense.json';
import itSettings from './locales/it/settings.json';
import itReports from './locales/it/reports.json';
import itPlans from './locales/it/plans.json';
import itQuote from './locales/it/quote.json';
import itAccountant from './locales/it/accountant.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enInvoice from './locales/en/invoice.json';
import enClient from './locales/en/client.json';
import enSupplier from './locales/en/supplier.json';
import enOnboarding from './locales/en/onboarding.json';
import enProfile from './locales/en/profile.json';
import enProduct from './locales/en/product.json';
import enExpense from './locales/en/expense.json';
import enSettings from './locales/en/settings.json';
import enReports from './locales/en/reports.json';
import enPlans from './locales/en/plans.json';
import enQuote from './locales/en/quote.json';
import enAccountant from './locales/en/accountant.json';

export const SUPPORTED_LANGUAGES = ['it', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// Resolve initial language: read from localStorage, fall back to 'it'
const stored = localStorage.getItem('i18nextLng');
const initialLng: SupportedLanguage = (SUPPORTED_LANGUAGES as readonly string[]).includes(stored ?? '')
  ? (stored as SupportedLanguage)
  : 'it';

const resources = {
  it: {
    common: itCommon,
    auth: itAuth,
    dashboard: itDashboard,
    invoice: itInvoice,
    client: itClient,
    supplier: itSupplier,
    onboarding: itOnboarding,
    profile: itProfile,
    product: itProduct,
    expense: itExpense,
    settings: itSettings,
    reports: itReports,
    plans: itPlans,
    quote: itQuote,
    accountant: itAccountant,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    invoice: enInvoice,
    client: enClient,
    supplier: enSupplier,
    onboarding: enOnboarding,
    profile: enProfile,
    product: enProduct,
    expense: enExpense,
    settings: enSettings,
    reports: enReports,
    plans: enPlans,
    quote: enQuote,
    accountant: enAccountant,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: 'it',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
